import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NavHeader from "./components/Header/NavHeader";
import NavRoutes from "./components/Header/NavRoutes";
import EndPoints from "./containers/EndPoints";

import Login from "./components/Login/loginForgot";
import Authenticator from "./containers/Authenticator/Authenticator/Authenticator";
import EmailVerification from "./containers/Authenticator/EmailVerification/EmailCodeVerification";
import CodeVerification from "./containers/Authenticator/CodeVerifiaction/CodeVerification";
import SetUpEnvironmentCard from "../src/containers/Onboard/SetUpEnvironmentCard";
import ForgotPassword from "./components/Login/loginForgot/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/Login/loginForgot/ResetPassword/ResetPassword";
import MicrosoftAuthentication from "./containers/Authenticator/MicrosoftAuthentication/MicrosoftAuthentication";
import NotFound from "./components/Page404/NotFound";
import ProtectedRoute from "./components/ProtectedRoutes/ProtectedRoute";
import ChangePassword from "./components/Login/loginForgot/ChangePassword/ChangePassword";
import SupportPage from "./containers/Support/Support";
import Dashboard from "./containers/Dashboard";
import ApiUsageDashboard from "./containers/Dashboard/ApiUsageDashboard";
import EnsembleModelling from "./containers/EnsembleModelling";
import NewHome from "./containers/NewHome";
import { ReactFlowProvider } from "reactflow";
import CustomTable from "./containers/catalogue";
import JobList from "./containers/metaDataDeployment";
import { useMaster } from "./Contexts/MasterContext";
import DeploymentHistory from "./containers/metaDataDeployment/DeploymentHistory";
import EnsembleModellingV2 from "./containers/Ensemble Modelling V2";
import DataMartModelling from "./containers/DataMartModelling";
import DataVaultModelling from "./containers/DataVaultModelling";
import { MappingWorkspace } from "./containers/mapping/MappingWorkspace";
import MetadataDeploymentHelp from "./containers/Help/MetadataDeploymentHelp";
// import JobList from "./containers/metaDataDeployment";

const EnvironmentDetails = React.lazy(
  () => import("./containers/EnvironmentDetails")
);
const DataSources = React.lazy(() => import("./containers/DataSources"));
const DataSourcesBeta = React.lazy(
  () => import("./containers/DataSourcesBeta")
);
const ImportDataSources = React.lazy(
  () => import("./containers/DataSources/ImportDataSources")
);
const UserAdminPage = React.lazy(() => import("./containers/UserAdminPage"));
const CustomPlugInManagement = React.lazy(
  () => import("./containers/CustomPlugInManagement")
);

const DataLineage = React.lazy(() => import("./containers/DataLineage"));
const DataLineageNew = React.lazy(() => import("./containers/DataLineageNew"));
const ImportDataModel = React.lazy(
  () => import("./containers/ImportDataModel")
);
const JobManagement = React.lazy(() => import("./containers/JobManagement"));
const JobDetails = React.lazy(
  () => import("./containers/JobManagement/JobDetails")
);
const JobDependency = React.lazy(() => import("./containers/JobDependency"));

function App() {
  const [updateEnvironmentd, setUpdateEnvironmentd] = useState<number | undefined>(
    undefined
  );
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const isLoggedInHandler = () => {
    setIsLoggedIn(true);
  };
  const updateEnvironmentsDetails = (environmentId?: number) => {
    setUpdateEnvironmentd(environmentId);
  };

  const [routeBlocker, setRouteBlocker] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // const [togle, setTogle] = useState(false)
  const isMaster = useMaster();

  useEffect(() => {
    if (isMaster.isMaster) {
      setRouteBlocker(false);
    } else {
      setRouteBlocker(true)
    }
  }, [isMaster]);

  return (
    <div className="wade-portal">
      <BrowserRouter>
        <div className="app-container">
          {localStorage.getItem("isLoggedIn") === "true" &&
            <NavHeader
              updateEnvironmentsDetails={updateEnvironmentsDetails}
              isLoggedIn={isLoggedIn}
            // togle = {togle}
            />
          }
          <div className="sidebar-app-container">
            {localStorage.getItem("isLoggedIn") === "true" &&
              <div className={`sidebar-container ${isSidebarCollapsed ? "collapsed" : ""}`}>
                <NavRoutes
                  isLoggedIn={isLoggedIn}
                  routeBlocker={routeBlocker}
                  isCollapsed={isSidebarCollapsed}
                  onToggleCollapse={setIsSidebarCollapsed}
                />
              </div>
            }
            <div className="routes-container">
              <Routes>
                <Route
                  path="/"
                  element={
                    localStorage.getItem("isLoggedIn") === "true" ? (
                      <Navigate to="/home" replace />
                    ) : (
                      <Login
                        isLoggedInHandler={isLoggedInHandler}
                      />
                    )
                  }
                />

                <Route path="/forgot_password" element={<ForgotPassword />} />
                <Route path="/reset_password" element={<ResetPassword />} />
                <Route path="/change_password" element={<ChangePassword />} />

                <Route
                  path="/onboard"
                  element={
                    <ProtectedRoute>
                      <SetUpEnvironmentCard
                        isLoggedInHandler={isLoggedInHandler}
                      />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/help/metadata-deployment"
                  element={
                    <ProtectedRoute>
                      <MetadataDeploymentHelp />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <ReactFlowProvider>
                          <NewHome />
                        </ReactFlowProvider>
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/dashboard/api-call-summary"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <ApiUsageDashboard />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                {!routeBlocker &&
                  <Route
                    path="/importDataModel"
                    element={
                      <Suspense fallback={<div> Please Wait... </div>}>
                        <ProtectedRoute>
                          <ImportDataModel />
                        </ProtectedRoute>
                      </Suspense>
                    }
                  />
                }
                <Route
                  path="/ensembleModelling"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <EnsembleModelling />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/data-mart-modelling"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <DataMartModelling />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/workspaceDetails"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <EnvironmentDetails
                          updateEnvironmentd={updateEnvironmentd}
                          setRouteBlocker={setRouteBlocker}
                        />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/dataSources"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <DataSources />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/dataSources/beta"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <DataSourcesBeta />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/importaDataSource"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <ImportDataSources />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/endPoints"
                  element={
                    <ProtectedRoute>
                      <EndPoints />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/adminPage"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <UserAdminPage />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route path="/authenticator" element={<Authenticator />} />
                <Route
                  path="/emailVerification"
                  element={<EmailVerification />}
                />
                <Route
                  path="/microsoftVerification"
                  element={<MicrosoftAuthentication />}
                />
                <Route
                  path="/codeVerification"
                  element={
                    <CodeVerification
                      length={6}
                      isLoggedInHandler={isLoggedInHandler}
                    />
                  }
                />
                <Route
                  path="/jobManagement"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <JobManagement />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/jobManagement/:id"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <JobDetails />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/customPlugin"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <CustomPlugInManagement />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/jobDependency"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <JobDependency page={false} />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/jobTaskGroupDependency/:refreshJobId"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <JobDependency page={true} />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/dataLineage"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <DataLineage />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/data-lineage-v2"
                  element={
                    <Suspense fallback={<div> Please Wait... </div>}>
                      <ProtectedRoute>
                        <DataLineageNew />
                      </ProtectedRoute>
                    </Suspense>
                  }
                />
                <Route
                  path="/support"
                  element={
                    <ProtectedRoute>
                      <SupportPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dataCatalog"
                  element={
                    <ProtectedRoute>
                      <CustomTable />
                    </ProtectedRoute>
                  }
                />
                {!routeBlocker &&
                  <>
                    <Route
                      path="/metaDataDeployment"
                      element={
                        <ProtectedRoute>
                          <JobList />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/deploymentHistory"
                      element={
                        <ProtectedRoute>
                          <DeploymentHistory />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/ensemble-modelling/:environmentId/:modelId"
                      element={
                        <ProtectedRoute>
                          <EnsembleModellingV2 />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/ensemble-modelling"
                      element={
                        <ProtectedRoute>
                          <EnsembleModellingV2 />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/EnsembleModellingV2"
                      element={
                        <ProtectedRoute>
                          <EnsembleModellingV2 />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/data-vault-modelling"
                      element={
                        <ProtectedRoute>
                          <DataVaultModelling />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/mapping-workspace"
                      element={
                        <ProtectedRoute>
                          <MappingWorkspace />
                        </ProtectedRoute>
                      }
                    />
                  </>
                }
                {localStorage.getItem("isLoggedIn") === "true" && (
                  <Route path="*" element={<NotFound />} />
                )}
              </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}
// hot fix- for client

export default App;
